import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { database } from "../../firebase";
import { ref, onValue, query, orderByChild, set, update, equalTo } from "firebase/database";
import { getFirestore, collection, query as queryFire, where, getDocs, updateDoc, doc, getDoc } from "firebase/firestore";
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Box, Alert, Snackbar, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import logo from '../../cbalogo.jpeg';
import emailjs from '@emailjs/browser';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { getCuadrillaById, getCuadrillaEmailById } from '../../services/cuadrillasService';
import { downloadDevolucionExcel } from '../../utils/devolucionExcel';
import { formatDate } from '../../utils/dateUtils';

const firestore = getFirestore();

function FacturaRemito({ dataRemito, isPreview }) {
    let { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [factura, setFactura] = useState([]);
    const [emailLoading, setEmailLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [openEmailModal, setOpenEmailModal] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState('');
    const [emailLoadingCuadrilla, setEmailLoadingCuadrilla] = useState(false);

    useEffect(() => {
        if (isPreview) {
            setFactura(dataRemito);
        } else {
            // const remitoQuery = query(ref(database, 'remitos'), orderByChild('id'), equalTo(parseInt(id, 10)));
            // onValue(remitoQuery, (snapshot) => {
            //     setFactura(Object.values(snapshot.val())[0]);
            // }, {
            //     onlyOnce: true
            // });
            getById(parseInt(id, 10));
        }
    }, []);

    const getById = async (id) => {
        console.log('🔍 === INICIO FacturaRemito.getById ===');
        console.log('🔍 Buscando remito con ID:', id);
        
        const cuadrillasCollection = collection(firestore, 'remitos');
        const q = queryFire(cuadrillasCollection, where('id', '==', id));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                console.log('🔍 Documento encontrado:', data);
                console.log('🔍 Seriales en el remito:', data.serials?.length || 0);
                console.log('🔍 Detalle seriales:', data.serials?.map(s => ({ id: s.id, tipo: s.tipo })) || []);
                
                setFactura(data);
            });
        } else {
            console.log("❌ No se encontró ningún documento con ese id.");
        }
        
        console.log('🔍 === FIN FacturaRemito.getById ===');
    }

    const print = () => {
        // Usar window.print() directamente sin manipular el DOM
        // Los estilos CSS @media print se encargarán de mostrar solo el contenido necesario
        window.print();
    }

    const goBackToList = () => {
        // Obtener los query parameters de la URL actual para preservar los filtros
        const currentParams = new URLSearchParams(window.location.search);
        
        // Si no hay parámetros, usar página 1 por defecto
        if (currentParams.toString() === '') {
            navigate('/remito-list?page=1');
            return;
        }
        
        // Preservar todos los filtros existentes
        const queryString = currentParams.toString();
        navigate(`/remito-list?${queryString}`);
    }

    // Función para obtener los emails de las cuadrillas origen y destino
    const getCuadrillasEmails = async () => {
        try {
            console.log('🔍 Obteniendo emails de cuadrilla origen y destino...');
            const emails = [];

            // 1. Obtener email de origen
            let emailOrigen = '';
            if (factura.emailCuadrillaEntrega && factura.emailCuadrillaEntrega.trim() !== '') {
                emailOrigen = factura.emailCuadrillaEntrega.trim();
            } else if (factura.idCuadrillaEntrega) {
                emailOrigen = await getCuadrillaEmailById(factura.idCuadrillaEntrega);
            }
            if (emailOrigen) {
                emails.push(emailOrigen);
            }

            // 2. Obtener email de destino
            let emailDestino = '';
            if (factura.emailCuadrillaReceptora && factura.emailCuadrillaReceptora.trim() !== '') {
                emailDestino = factura.emailCuadrillaReceptora.trim();
            } else if (factura.idCuadrillaReceptora) {
                emailDestino = await getCuadrillaEmailById(factura.idCuadrillaReceptora);
            }
            if (emailDestino) {
                emails.push(emailDestino);
            }

            console.log('✅ Emails encontrados:', emails);
            return emails.join(', ');
        } catch (error) {
            console.error('❌ Error al obtener emails de cuadrillas:', error);
            return '';
        }
    };

    // Función para generar PDF del remito optimizado
    const generatePDF = async () => {
        try {
            const element = document.getElementById('printContent');
            if (!element) {
                throw new Error('No se encontró el contenido para generar el PDF');
            }

            // Configuración optimizada para menor tamaño de archivo
            const canvas = await html2canvas(element, {
                scale: 1.2, // Reducido de 2 a 1.2 para menor tamaño
                logging: false,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                removeContainer: true,
                imageTimeout: 0,
                quality: 0.8 // Reducir calidad para menor tamaño
            });

            // Usar JPEG en lugar de PNG para menor tamaño
            const imgData = canvas.toDataURL('image/jpeg', 0.7); // 70% calidad
            const pdf = new jsPDF('p', 'mm', 'a4');
            
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 295; // A4 height in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;

            // Agregar primera página
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            // Agregar páginas adicionales si es necesario
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }

            const pdfBlob = pdf.output('blob');
            
            // Verificar tamaño del PDF
            const sizeInKB = pdfBlob.size / 1024;
            console.log(`Tamaño del PDF: ${sizeInKB.toFixed(2)} KB`);
            
            // Si el PDF es muy grande, intentar una versión más comprimida
            if (sizeInKB > 40) { // Límite conservador para base64
                console.log('PDF muy grande, generando versión comprimida...');
                return await generateCompressedPDF(element);
            }

            return pdfBlob;
        } catch (error) {
            console.error('Error al generar PDF:', error);
            throw error;
        }
    };

    // Función para generar PDF ultra comprimido
    const generateCompressedPDF = async (element) => {
        try {
            // Configuración mínima para máxima compresión
            const canvas = await html2canvas(element, {
                scale: 0.8, // Escala muy reducida
                logging: false,
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                quality: 0.5 // Calidad mínima
            });

            const imgData = canvas.toDataURL('image/jpeg', 0.4); // 40% calidad
            const pdf = new jsPDF('p', 'mm', 'a4');
            
            const imgWidth = 210;
            const pageHeight = 295;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
            
            const pdfBlob = pdf.output('blob');
            const sizeInKB = pdfBlob.size / 1024;
            console.log(`Tamaño del PDF comprimido: ${sizeInKB.toFixed(2)} KB`);
            
            return pdfBlob;
        } catch (error) {
            console.error('Error al generar PDF comprimido:', error);
            throw error;
        }
    };

    // Función para enviar email con template HTML (sin PDF)
    const sendEmailWithHTML = async (emailData, receiver) => {
        try {
            console.log('📧 Preparando email con template HTML...');
            
            // Preparar datos para el template HTML
            const emailParams = {
                title: `${factura.tipoRemito} de Materiales #${factura.id}`,
                subject: `${factura.tipoRemito} de Materiales #${factura.id}`,
                to_name: "Cuadrilla Receptora",
                to_email: receiver,
                from_name: "CBA Construir",
                message: emailData.message,
                
                // Datos del remito
                tipo_remito: factura.tipoRemito,
                remito_number: factura.id,
                numero_remito_formatted: factura.id?.toString().padStart(5, '0'),
                fecha_confeccion: factura.confectionDate ? moment(factura.confectionDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY") : '',
                cuadrilla_origen: factura.cuadrillaEntrega,
                cuadrilla_destino: factura.cuadrillaReceptora,
                fecha_entrega: formatDate(factura.fecha),
                shelf_position: factura.shelfPosition ? `(P.E: ${factura.shelfPosition})` : '', // Add shelf position
                observaciones_generales: factura.observaciones || '',
                
                // Convertir arrays a strings HTML para EmailJS
                controles_html: factura.controles?.map(control => 
                    `<tr>
                        <td width="14%">${control.id || ''}</td>
                        <td width="49%">Control ${(control.name || '').toUpperCase()}</td>
                        <td width="9%">${control.value || ''}</td>
                        <td width="24%">${control.observaciones || ''}</td>
                    </tr>`
                ).join('') || '',
                
                materials_html: factura.materials?.map(material => 
                    `<tr>
                        <td width="14%">${material.id || ''}</td>
                        <td width="49%">${material.name || ''}</td>
                        <td width="9%">${material.value || ''}</td>
                        <td width="24%">${material.observaciones || ''}</td>
                    </tr>`
                ).join('') || '',
                
                serials_html: factura.serials?.map((serial, index) => 
                    `<tr>
                        <td width="6%" style="text-align: center;">${index + 1}</td>
                        <td width="14%">${(serial.tipo || '').trim().toUpperCase()}</td>
                        <td width="46%">${serial.id || ''}</td>
                        <td width="34%">${serial.observaciones || ''}</td>
                    </tr>`
                ).join('') || ''
            };
            
            console.log('📧 === PARÁMETROS EMAILJS HTML ===');
            console.log('📧 to_email:', emailParams.to_email);
            console.log('📧 subject:', emailParams.subject);
            console.log('📧 controles_html length:', emailParams.controles_html?.length || 0);
            console.log('📧 materials_html length:', emailParams.materials_html?.length || 0);
            console.log('📧 serials_html length:', emailParams.serials_html?.length || 0);
            
            return emailjs.send("service_dtta4bo", "template_n45n6wy", emailParams, 'G-CNczSPmMLzPKizx')
                .then((result) => {
                    console.log('✅ Email HTML enviado exitosamente:', result);
                    return result;
                })
                .catch((error) => {
                    console.error('❌ Error al enviar email HTML:', error);
                    throw error;
                });
                
        } catch (error) {
            console.error('❌ Error en sendEmailWithHTML:', error);
            throw error;
        }
    };

    // Función para enviar email sin adjunto (solo notificación)
    const sendNotificationEmail = async (emailData, receiver) => {
        try {
            return emailjs.send("service_dtta4bo", "template_n45n6wy", {
                title: `${factura.tipoRemito} de Materiales #${factura.id} - Disponible en Sistema`,
                subject: `${factura.tipoRemito} de Materiales #${factura.id} - Disponible en Sistema`,
                to_name: "Cuadrilla Receptora",
                remito_number: factura.id,
                cuadrilla_origen: factura.cuadrillaEntrega,
                cuadrilla_destino: factura.cuadrillaReceptora,
                fecha_entrega: formatDate(factura.fecha),
                message: emailData.message,
                attachment_name: "No adjunto - Ver en sistema",
                from_name: "CBA Construir",
                to_email: receiver,
                attachment_data: ""
            }, 'G-CNczSPmMLzPKizx');
        } catch (error) {
            console.error('Error al enviar email de notificación:', error);
            throw error;
        }
    };

    const handleOpenEmailModal = async () => {
        setOpenEmailModal(true);
        setEmailLoadingCuadrilla(true);
        setRecipientEmail('');

        try {
            const email = await getCuadrillasEmails();
            setRecipientEmail(email);
        } catch {
            setRecipientEmail('');
        } finally {
            setEmailLoadingCuadrilla(false);
        }
    };

    const handleCloseEmailModal = () => {
        setOpenEmailModal(false);
        setRecipientEmail('');
        setEmailLoading(false);
    };

    const handleSendEmail = async () => {
        try {
            setEmailLoading(true);

            if (!recipientEmail || recipientEmail.trim() === '') {
                throw new Error('Por favor ingrese un email válido');
            }

            // Validar cada correo electrónico ingresado separado por comas o punto y coma
            const emails = recipientEmail.split(/[\s,;]+/).filter(Boolean);
            if (emails.length === 0) {
                throw new Error('Por favor ingrese al menos un email válido');
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            for (const email of emails) {
                if (!emailRegex.test(email)) {
                    throw new Error(`El email "${email}" no tiene un formato válido`);
                }
            }

            const emailData = {
                message: `Se adjunta ${factura.tipoRemito} de materiales desde ${factura.cuadrillaEntrega} hacia ${factura.cuadrillaReceptora}. El remito se muestra completo en este email con todos los detalles, materiales y equipos.`
            };

            await sendEmailWithHTML(emailData, recipientEmail.trim());

            setSnackbar({ open: true, message: `Remito enviado exitosamente a ${recipientEmail}`, severity: 'success' });
            handleCloseEmailModal();

        } catch (error) {
            console.error('Error al enviar remito por email:', error);
            setSnackbar({ open: true, message: `Error al enviar email: ${error.message}`, severity: 'error' });
        } finally {
            setEmailLoading(false);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    return (
        <Container component="main">
            {!isPreview &&
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 2, gap: 2 }} className="no-print">
                    <Button
                        variant="text"
                        onClick={goBackToList}
                        startIcon={<ArrowBackIcon />}
                        sx={{ 
                            alignSelf: 'flex-start',
                            color: '#1976d2',
                            '&:hover': {
                                backgroundColor: '#e3f2fd'
                            }
                        }}
                    >
                        Volver al Listado
                    </Button>
                    
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            onClick={print}
                            endIcon={<PrintIcon />}
                            className="button-print"
                            sx={{
                                backgroundColor: 'black',
                                '&:hover': { backgroundColor: '#424242' },
                                minWidth: '120px'
                            }}
                        >
                            Imprimir
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleOpenEmailModal}
                            endIcon={<EmailIcon />}
                            sx={{
                                backgroundColor: '#2e7d32',
                                '&:hover': { backgroundColor: '#1b5e20' },
                                minWidth: '140px'
                            }}
                        >
                            Enviar Email
                        </Button>
                        {factura?.tipoRemito === 'DEVOLUCION' && (
                            <Button
                                variant="contained"
                                onClick={() => downloadDevolucionExcel(factura)}
                                endIcon={<FileDownloadIcon />}
                                sx={{
                                    backgroundColor: '#1565c0',
                                    '&:hover': { backgroundColor: '#0d47a1' },
                                    minWidth: '160px'
                                }}
                            >
                                Descargar Excel
                            </Button>
                        )}
                    </Box>
                </Box>
            }

            <div id="printContent">
                <div className="factura__container">
                    <div className="header-section">
                        <div className="col-12">
                            <h4 className="title-remito">{factura.tipoRemito} DE MATERIALES</h4>
                        </div>
                    </div>
                    <div className="row section">
                        <div className="logo-header">
                            <img decoding="async" width="150" height="80" src={logo} className="elementor-animation-grow attachment-large size-large" alt="" loading="lazy" />
                        </div>
                        {!isPreview &&
                            <div className="col-4 details">
                                {factura?.confectionDate &&
                                    <span style={{ display: 'block' }}>
                                        Fecha: {moment(factura.confectionDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY")}
                                    </span>
                                }
                                <span>
                                    Número #: 001 - {factura?.id?.toString().padStart(5, '0')}
                                </span>
                            </div>
                        }
                        <div className="col-6 data-client">
                            <span className="client">
                                <strong>
                                    Cuadrilla Origen: {' '}
                                </strong>
                                {factura.cuadrillaEntrega}
                                <br />
                                <br />
                                <strong>
                                    Cuadrilla Destino: {' '}
                                </strong>
                                {factura.cuadrillaReceptora}
                                <br />
                                <br />
                                <strong>
                                    Fecha estipulada entrega:{' '}
                                </strong>
                                {formatDate(factura.fecha)}
                                {factura.shelfPosition && ` (P.E: ${factura.shelfPosition})`}
                            </span>
                        </div>
                    </div>

                    <div className="invoicelist-body">
                        <table className="table-container">
                            <thead>
                                <tr>
                                    <th width="14%">PRODUCTO_ID</th>
                                    <th width="49%">NOMBRE</th>
                                    <th width="9%">CANTIDAD</th>
                                    <th width="24%">OBSERVACIONES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {factura?.controles?.map((control, index) => {
                                    return (
                                        <tr key={index}>
                                            <td width="14%">
                                                <span>{control.id}</span>
                                            </td>
                                            <td width="49%">
                                                <span>Control {control?.name.toUpperCase()}</span>
                                            </td>
                                            <td width="9%">
                                                <span>{control.value}</span>
                                            </td>
                                            <td width="24%">
                                                <span>{control.observaciones || ''}</span>
                                            </td>
                                        </tr>
                                    );
                                })}
                                {factura?.materials?.map((prod, index) => {
                                    return (
                                        <tr key={index}>
                                            <td width="14%">
                                                <span>{prod.id}</span>
                                            </td>
                                            <td width="49%">
                                                <span>{prod.name}</span>
                                            </td>
                                            <td width="9%">
                                                <span>{prod.value}</span>
                                            </td>
                                            <td width="24%">
                                                <span>{prod.observaciones}</span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="invoicelist-body">
                        <table className="table-container">
                            <caption className="comments">COMENTARIOS: {factura?.observaciones || ''}</caption>
                            <caption>EQUIPOS</caption>
                            <thead>
                                {factura?.tipoRemito === 'DEVOLUCION' ? (
                                    <tr>
                                        <th width="5%">#</th>
                                        <th width="10%">TIPO</th>
                                        <th width="25%">NUMERO DE SERIE</th>
                                        <th width="15%">NRO WO</th>
                                        <th width="18%">FECHA DE ASISTENCIA</th>
                                        <th width="27%">OBSERVACIONES</th>
                                    </tr>
                                ) : (
                                    <tr>
                                        <th width="6%">#</th>
                                        <th width="14%">TIPO</th>
                                        <th width="46%">NUMERO DE SERIE</th>
                                        <th width="34%">OBSERVACIONES</th>
                                    </tr>
                                )}
                            </thead>
                            <tbody>
                                {factura?.serials?.map((serial, index) => {
                                    if (factura?.tipoRemito === 'DEVOLUCION') {
                                        return (
                                            <tr key={index}>
                                                <td width="5%"><span>{index + 1}</span></td>
                                                <td width="10%"><span>{(serial?.tipo || '').trim().toUpperCase()}</span></td>
                                                <td width="25%"><span>{serial.id}</span></td>
                                                <td width="15%"><span>{serial.nroWO || ''}</span></td>
                                                <td width="18%"><span>{serial.fechaAsistencia || ''}</span></td>
                                                <td width="27%"><span>{serial.observaciones || ''}</span></td>
                                            </tr>
                                        );
                                    }
                                    return (
                                        <tr key={index}>
                                            <td width="6%">
                                                <span>{index + 1}</span>
                                            </td>
                                            <td width="14%">
                                                <span>{(serial?.tipo || '').trim().toUpperCase()}</span>
                                            </td>
                                            <td width="46%">
                                                <span>{serial.id}</span>
                                            </td>
                                            <td width="34%">
                                                <span>{serial.observaciones || ''}</span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <div className="invoicelist-footer">
                        <table>
                            {/* <tr className="taxrelated">
              <td>IVA:</td>
              <td id="total_tax"></td>
            </tr> */}
                            <tbody>
                                <tr>
                                    <td>
                                        <span>Firma:</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span>Aclaración:</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            
            <Dialog open={openEmailModal} onClose={handleCloseEmailModal} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <EmailIcon sx={{ color: '#2e7d32' }} />
                        Enviar Remito por Email
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ marginBottom: 2 }}>
                        {factura && (
                            <>
                                Enviar <strong>{factura.tipoRemito} #{factura.id}</strong>
                                <br />
                                Desde: <strong>{factura.cuadrillaEntrega}</strong>
                                <br />
                                Hacia: <strong>{factura.cuadrillaReceptora}</strong>
                            </>
                        )}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Email del destinatario"
                        type="email"
                        fullWidth
                        variant="outlined"
                        value={recipientEmail}
                        onChange={(e) => setRecipientEmail(e.target.value)}
                        disabled={emailLoadingCuadrilla || emailLoading}
                        placeholder="ejemplo@email.com"
                        helperText={emailLoadingCuadrilla ? 'Obteniendo email de la cuadrilla...' : 'Ingrese el email donde enviar el remito'}
                        InputProps={{
                            endAdornment: emailLoadingCuadrilla && <CircularProgress size={20} />
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEmailModal} disabled={emailLoading}>
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSendEmail}
                        variant="contained"
                        disabled={emailLoading || !recipientEmail.trim()}
                        startIcon={emailLoading ? <CircularProgress size={16} /> : <SendIcon />}
                        sx={{ backgroundColor: '#2e7d32', '&:hover': { backgroundColor: '#1b5e20' } }}
                    >
                        {emailLoading ? 'Enviando...' : 'Enviar'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar para notificaciones */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert 
                    onClose={handleCloseSnackbar} 
                    severity={snackbar.severity}
                    sx={{ 
                        width: '100%',
                        minWidth: '400px',
                        maxWidth: '600px'
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default FacturaRemito
